export default __webpack_public_path__ + "static/media/LogoInter-w.fb030bff.svg";